import React from 'react'
//import EstiloStyles from './EstiloStyles.css'
import Box from 'grommet/components/Box';
import Label from 'grommet/components/Label';
//import Content from './Content'
import Content2 from './Content2'
import Data from './data/Data'
import Sidebar from "./Sidebar"
import MenuIcon from 'grommet/components/icons/base/Menu';
import Button from 'grommet/components/Button';
import Elements from "./components/Elements.js"
import {statisticsFitModel, statisticsExplore} from "./data/Data"
const components = Data;


//const App = () => {
class App extends React.Component {
    constructor() {
        super();
        this._onSelectStatisticsExplore = this._onSelectStatisticsExplore.bind(this);
        this._onSelectStatisticsFitModel = this._onSelectStatisticsFitModel.bind(this);
        this._onOpen = this._onOpen.bind(this);
        this._onClose = this._onClose.bind(this);
        this.state = { title: components[0].title, 
                       tag:components[0].tag, 
                       description: components[0].description, 
                       route: components[0].route, 
                       contentDOC: components[0].contentDOC, 
                       contentDEMO: components[0].contentDEMO, 
                       contentDEMOReact: components[0].contentDEMOReact, 
                       contentDEMOJQ: components[0].contentDEMOJQ, 
                       contentDEMOVue: components[0].contentDEMOVue,
                       src: components[0].src,
                       sidebarFlag: false
                    }
    }
    _onClose() {
        this.setState({sidebarFlag: false})
    }
    _onOpen() {
        this.setState({sidebarFlag: true})
    }
    _onSelectStatisticsExplore(element) {
        if (statisticsExplore[element]) {
            document.documentElement.scrollTop = 0; // For IE and Firefox
            components.map((item) => {
            if (statisticsExplore[element].name === item.title) {
                this.setState({ title: item.title, 
                                tag: item.tag, 
                                description: item.description, 
                                route: item.route, 
                                contentDOC: item.contentDOC, 
                                contentDEMO: item.contentDEMO, 
                                contentDEMOReact: item.contentDEMOReact, 
                                contentDEMOJQ: item.contentDEMOJQ, 
                                contentDEMOVue: item.contentDEMOVue,
                                src: item.src,
                                sidebarFlag: false
                            })
            }
            return null
            })
        }
        
        /* document.body.scrollTop = 0; // For Chrome, Safari and Opera 
        document.documentElement.scrollTop = 0; // For IE and Firefox
        components.map((item) => {
            if (component === item.title) {
                this.setState({ title: item.title, 
                                tag: item.tag, 
                                description: item.description, 
                                route: item.route, 
                                contentDOC: item.contentDOC, 
                                contentDEMO: item.contentDEMO, 
                                contentDEMOReact: item.contentDEMOReact, 
                                contentDEMOJQ: item.contentDEMOJQ, 
                                contentDEMOVue: item.contentDEMOVue,
                                src: item.src,
                                sidebarFlag: false
                            })
            }
            return null
        }) */

    }
    _onSelectStatisticsFitModel(element) {
        if (statisticsFitModel[element]) {
            document.documentElement.scrollTop = 0; // For IE and Firefox
            components.map((item) => {
            if (statisticsFitModel[element].name === item.title) {

                this.setState({ title: item.title, 
                                tag: item.tag, 
                                description: item.description, 
                                route: item.route, 
                                contentDOC: item.contentDOC, 
                                contentDEMO: item.contentDEMO, 
                                contentDEMOReact: item.contentDEMOReact, 
                                contentDEMOJQ: item.contentDEMOJQ, 
                                contentDEMOVue: item.contentDEMOVue,
                                src: item.src,
                                sidebarFlag: false
                            })
            }
            return null
            })
        }
        
        /* document.body.scrollTop = 0; // For Chrome, Safari and Opera 
        document.documentElement.scrollTop = 0; // For IE and Firefox
         */

    }
    render() {
        const {title, sidebarFlag} = this.state;
        let content;
        if (title === 'Home' || title === 'Get Started') {
            return (
                <Elements 
                statisticsExplore={statisticsExplore} 
                statisticsFitModel={statisticsFitModel} 
                onSelectStatisticsExplore={this._onSelectStatisticsExplore} 
                onSelectStatisticsFitModel={this._onSelectStatisticsFitModel} />
            )
            /* content = components.map((item, key) => {
                const Icon = item.icon;
                return (
                        <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            
                            <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                                {(item.description)? <a onClick={this.onClick.bind(this, item.title)}><Label>{item.title}</Label></a> : <div><b>{item.title}</b></div> }
                            </Box>
                        </Box>
                );
              }); */
          
            /* content = <Content title={this.state.title} 
                                tag={this.state.tag} 
                                description={this.state.description} 
                                route={this.state.route} 
                                contentDOC={this.state.contentDOC} 
                                contentDEMO={this.state.contentDEMO} 
                                contentDEMOReact={this.state.contentDEMOReact} 
                                contentDEMOJQ={this.state.contentDEMOJQ} 
                                contentDEMOVue={this.state.contentDEMOVue}/> */
        } else {
            content = <Content2 title={this.state.title} 
                                tag={this.state.tag} 
                                description={this.state.description} 
                                route={this.state.route} 
                                contentDOC={this.state.contentDOC} 
                                contentDEMO={this.state.contentDEMO} 
                                contentDEMOReact={this.state.contentDEMOReact} 
                                contentDEMOJQ={this.state.contentDEMOJQ} 
                                contentDEMOVue={this.state.contentDEMOVue}
                                src={this.state.src} />
        }
        //<style> {Appstyles} </style>
        return (
            <div>
                <Button icon={<MenuIcon />} onClick={this._onOpen} plain={true}/>
                {sidebarFlag && <Sidebar onClose={this._onClose} onSelectExplore={this._onSelectStatisticsExplore} onSelectFitModel={this._onSelectStatisticsFitModel}/>}
                    <div style={{padding: "50px"}}>
                        {content}
                    </div>    
            </div>
        );
    }
}

export default App



// WEBPACK FOOTER //
// ./src/Estilo.js